import cx from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  fontFamily: string;
  backgroundColor?: string;
  fontSize?: 'sm' | 'lg';
  textColor?: string;
  autoFocus?: boolean;
  placeholderText?: string;
  setEmail: (email: string) => void;
  onEmailChange?: (email: string) => void;
  className?: string;
}

const EmailInput = ({
  backgroundColor,
  fontFamily,
  fontSize,
  // biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
  textColor,
  autoFocus,
  placeholderText,
  setEmail,
  onEmailChange,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <input
      type="email"
      name="email"
      autoComplete="email"
      autoFocus={autoFocus}
      required
      style={{
        ...(backgroundColor && { borderColor: backgroundColor }),
        ...(fontFamily && { fontFamily: fontFamily }),
        color: '#111827',
      }}
      className={cx(
        'wt-button-font z-10 w-full border-none bg-transparent placeholder-shown:text-ellipsis',
        {
          'text-lg focus:text-lg active:text-lg sm:text-lg': !fontSize || fontSize === 'lg',
        },
        { 'text-sm focus:text-sm active:text-sm': fontSize === 'sm' },
        className,
      )}
      onChange={(e) => {
        setEmail(e.target.value);

        if (onEmailChange) {
          onEmailChange(e.target.value);
        }
      }}
      placeholder={placeholderText || t('subscribe.email_placeholder') || ''}
    />
  );
};

export default EmailInput;
